/**
 * JOServicesSpotlightInjector — mounts JOServicesSpotlight at the top of
 * /shop via a portal, without touching cockpit ShopPage.jsx.
 */
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import JOServicesSpotlight from "./sections/JOServicesSpotlight";

const HOST_ID = "jo-services-spotlight-host";

export default function JOServicesSpotlightInjector() {
  const location = useLocation();
  const [host, setHost] = useState(null);

  useEffect(() => {
    const prev = document.getElementById(HOST_ID);
    if (prev) prev.remove();
    setHost(null);
    if (location.pathname !== "/shop" && !location.pathname.startsWith("/shop/")) return;
    if (location.pathname.startsWith("/shop/") && location.pathname.length > 6) return; // skip product detail
    let cancelled = false;
    const attach = () => {
      if (cancelled) return true;
      const main = document.querySelector("main") || document.body;
      if (!main) return false;
      let el = document.getElementById(HOST_ID);
      if (!el) {
        el = document.createElement("div");
        el.id = HOST_ID;
        main.insertBefore(el, main.firstChild);
      }
      setHost(el);
      return true;
    };
    if (attach()) return;
    let tries = 0;
    const iv = setInterval(() => {
      tries++;
      if (attach() || tries > 20) clearInterval(iv);
    }, 200);
    return () => {
      cancelled = true;
      clearInterval(iv);
      const el = document.getElementById(HOST_ID);
      if (el) el.remove();
    };
  }, [location.pathname]);

  if (!host) return null;
  return createPortal(<JOServicesSpotlight compact />, host);
}
